var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.name!=='AllInfo'&&!_vm.isDialog)?_c('el-button',{staticStyle:{"padding":"0","margin-left":"10px"},attrs:{"type":"text"},on:{"click":_vm.goback}},[_c('i',{staticClass:"fa fa-arrow-circle-left fa-fw"}),_vm._v("返回")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e5edaf1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/goback/index.vue
// module id = null
// module chunks = 